import { localizedDateFormat } from '../utils/dateFormatters'

export default {
  methods: {
    datetime: (value, format = 'DD/MM/YYYY HH:mm') => {
      return localizedDateFormat(value, format)
    }
  }
}
